import { Delete, Edit } from "@mui/icons-material";
import dayjs from "dayjs";
import React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";



const handleFullScreen = (image) => {
  if(image && image.includes('http')){
    window.open(image, "_blank");
  }
};
const DragAndDropList = ({ promotionsList, handleEdit, handleDelete,dragAndDrop,onDragEnd,IsAdmin,dmb=false,type }) => {
  return (
    <DragDropContext onDragEnd={onDragEnd} >
      <Droppable droppableId="table" direction="vertical"  isDropDisabled={!dragAndDrop}>
        {(provided) => (
          <table
            className="min-w-full divide-y divide-gray-300"
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={{ width: "100%" }}
          >
            <thead className="bg-gray-50">
              <tr>
                {!dmb && <th
                  scope="col"
                  className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                >
                  Order
                </th>}
                
                <th
                  scope="col"
                  className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                >
                  Name
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                >
                  Image
                </th>
                 <th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                >
                  Active
                </th>
                {type==="mandatory" && (<><th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                >
                  Mandatory
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                >
                  Duration
                </th></>)}
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {promotionsList?.map((i, index) => (
                <Draggable isDragDisabled={!dragAndDrop} key={i?.intBannerID} draggableId={i?.intBannerID?.toString()} index={index}>
                  {(provided) => (
                    <tr
                      key={i?.intBannerID}
                      className="item-container"
                      style={{width:'100%'}}
                      ref={provided.innerRef}
                      {...provided.dragHandleProps}
                      {...provided.draggableProps}
                    >
                    
                      {!dmb &&   <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500 sm:pl-6">
                        <div className="text-gray-700">{i?.intBannerOrder }</div>
                      </td>}
                      <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500 sm:pl-6">
                        <div className="text-gray-700">{i?.vchBannerName}</div>
                      </td>

                      <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                        <div className="text-gray-700">
                          <img
                            width="85px"
                            height="85px"
                            src={i?.vchBannerURL}
                            onError={(event) => {
                              event.target.src = "../assets/icons/notfound.png";
                              event.onerror = null;
                            }}
                            alt="The current file"
                            onClick={()=>handleFullScreen(i?.vchBannerURL)}
                          />
                        </div>
                      </td>
                      <td className="whitespace-nowrap  py-1 text-sm text-gray-500 px-3 ">
                        <div className="text-gray-700">
                          {i?.bitActive ? "Yes" : "No"}
                        </div>
                      </td>
                      {type==="mandatory" && (<>
                        <td className="whitespace-nowrap  py-1 text-sm text-gray-500 px-3 ">
                        <div className="text-gray-700">
                          {i?.bitMandatory ? "Yes" : "No"}
                        </div>
                      </td>
                      <td className="whitespace-nowrap  py-1 text-sm text-gray-500 px-3 ">
                        <div className="text-gray-700">
                          {i?.bitMandatory
                            ? `${dayjs(i?.dteStartDate).format(
                                "MM/DD/YYYY"
                              )} - ${dayjs(i?.dteEndDate).format("MM/DD/YYYY")}`
                            : `NA`}
                        </div>
                      </td>
                      </>) }
                      <td className="whitespace-nowrap  py-1 text-sm text-gray-500 px-3 ">
                        <span
                          style={{ cursor: "pointer" }}
                          variant="contained"
                          onClick={() => handleEdit(i)}
                          className="text-primary hover:text-primary-dark"
                        >
                          <Edit />
                        </span>
                        {IsAdmin ?  <span
                          style={{ cursor: "pointer" }}
                          variant="contained"
                          onClick={() => handleDelete(i)}
                          className="text-primary hover:text-primary-dark"
                        >
                          <Delete />
                        </span> : null}
                       
                      </td>
                    </tr>
                  )}
                </Draggable>
              ))}
            </tbody>
            {provided.placeholder}
          </table>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DragAndDropList;
